<!--
 * @Description: 招商设置
 * @Date: 2022-09-19 11:03:48
-->
<template>
  <div class="config" v-xrk-loading="loading">
    <div class="left">
      <div class="left_wrap">
        <div v-if="isOssRole" class="enterprise-setting">
          <BaseInput
            style="width: 100%"
            :model-value="enterpriseName"
            disabled
          ></BaseInput>
          <div class="choose">
            <span>展示端口</span>
            <BaseCheckboxGroup
              class="box"
              :min="1"
              v-model="formData.platforms"
              :disabled="!edit || !isOwnPublish"
            >
              <BaseCheckbox
                v-for="item in ROAD_TYPE"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </BaseCheckbox>
            </BaseCheckboxGroup>
          </div>
        </div>
        <div
          v-if="configStatus && configStatusObj && !edit && isOwnPublish"
          style="
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 9px 14px;
            font-weight: bold;
            margin-bottom: 12px;
            border-radius: 2px;
            font-size: 14px;
          "
          :style="`background:var(${configStatusObj.color}-light-8);color:var(${configStatusObj.color});`"
        >
          <BaseIcon :size="18">
            <component :is="configStatusObj.icon"></component>
          </BaseIcon>
          <div>{{ configStatusObj.message }}</div>
        </div>
        <div class="item">
          <div class="title">
            <span>企业信息</span>
          </div>
          <BaseForm labelPosition="top" :model="logoFormData">
            <BaseFormItem
              label="企业logo"
              prop="enterpriseLogo"
              :required="true"
            >
              <div
                v-if="
                  isOtherPublish ||
                  ['review', 'success', 'fail'].includes(configStatus)
                "
              >
                <div style="width: 100px; height: 100px">
                  <BaseImage
                    @click="previewLogo(logoFormData.enterpriseLogo)"
                    :src="logoFormData.enterpriseLogo"
                  ></BaseImage>
                </div>
              </div>
              <div v-else>
                <BaseUpload
                  style="width: 100%"
                  v-model:fileList="loginFileList"
                  listType="picture-card"
                  :limitSize="0.2"
                  :limit="1"
                  :accept="['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG']"
                  :http-request="logoHttpRequest"
                  :autoUpload="true"
                  :onError="logoError"
                  :uploadBtnProps="{ limitOverHide: true }"
                >
                  <div
                    style="width: 100px; height: 100px"
                    v-if="logoFormData.enterpriseLogo"
                  >
                    <BaseImage :src="logoFormData.enterpriseLogo"></BaseImage>
                  </div>
                  <div v-else v-html="imgSvg"></div>
                  <template #tip>
                    <span style="color: red">不超过200k，建议尺寸64 x64px</span>
                  </template>
                </BaseUpload>
              </div>
            </BaseFormItem>
          </BaseForm>
        </div>
        <div class="item" style="margin-top: 0">
          <div class="title">
            <span>招商介绍（非必填）</span>
          </div>
          <div style="box-sizing: border-box; padding-right: 5px">
            <XrkTinymce
              :class="!edit || !isOwnPublish ? 'dis-edit' : ''"
              :value="formData.content"
              @input="onTinymceInput"
            />
          </div>
          <!-- <BaseInput
          type="textarea"
          placeholder="请输入招商介绍"
          :disabled="!edit || !isOwnPublish"
          :rows="10"
          :model-value="formData.content"
          :maxlength="100000"
          @input="onTinymceInput"
        ></BaseInput> -->
        </div>
        <div class="item">
          <div class="title">
            <span>产品信息</span>
            <BaseButton
              class="btn"
              plain
              @click="onAddProductClick"
              :disabled="!edit || !isOwnPublish"
            >
              添加产品
            </BaseButton>
          </div>
          <ConfigProductVue
            :disabled="!edit || !isOwnPublish"
            ref="ConfigProductRef"
            @change="newData => (formData.productData = newData)"
          ></ConfigProductVue>
        </div>
        <div class="item">
          <div class="title">
            <span>能力标签</span>
            <BaseButton
              class="btn"
              plain
              @click="onAddTagsClick"
              :disabled="!edit || !isOwnPublish"
            >
              选择能力标签
            </BaseButton>
          </div>
          <BaseEmpty
            v-if="formData.tags.length == 0"
            style="padding: 0"
            :image-size="80"
            description="暂未选择能力标签"
          ></BaseEmpty>
          <ConfigTagsVue
            v-else
            class="ability-label"
            :key="formData.tags.length"
            :disabled="!edit || !isOwnPublish"
            :data="(formData.tags as Array<TagType>)"
            @change="newTags => (formData.tags = newTags)"
            ref="ConfigTagsRef"
          ></ConfigTagsVue>
        </div>
        <div style="word-spacing: -4px; margin-top: 24px">
          <BaseCheckbox
            :disabled="
              isOtherPublish
                ? ['success', 'fail'].includes(configStatus)
                : ['review', 'success', 'fail'].includes(configStatus)
            "
            v-model="logoFormData.agreement"
          >
            <span>
              我已阅读并同意
              <BaseButton @click="agreementDioalog" type="text">
                《向日葵平台企业招商服务使用及管理规则》
              </BaseButton>
            </span>
          </BaseCheckbox>
        </div>
      </div>

      <div style="padding: 24px 0 0">
        <template v-if="isOtherPublish">
          <!-- 别人发布的，需要审核 -->
          <template v-if="configStatus === 'review'">
            <BaseButton :click="onSuccessClick">确认发布</BaseButton>
            <BaseButton :click="onFailClick">驳回修改</BaseButton>
          </template>
        </template>
        <template v-else>
          <!-- 自己发布的 -->
          <template v-if="!configStatus">
            <BaseButton :click="onPublishClick">发布招商</BaseButton>
            <BaseButton :click="onSaveClick">保存</BaseButton>
          </template>
          <template v-if="configStatus === 'review'">
            <BaseButton :click="onRevokeClick">撤回重新编辑</BaseButton>
          </template>

          <template v-if="configStatus === 'fail'">
            <BaseButton :click="onReEditClick">重新编辑</BaseButton>
          </template>

          <template v-if="configStatus === 'success'">
            <BaseButton :click="onReEditClick">重新编辑</BaseButton>
            <BaseButton :click="onStartClick" v-if="isStop">
              启用招商
            </BaseButton>
            <BaseButton :click="onStopClick" v-else>暂停招商</BaseButton>
          </template>
          <BaseButton
            type="warning"
            v-if="isOssRole && formData.id"
            :click="onCopyClick"
          >
            复制链接
          </BaseButton>
        </template>
      </div>
    </div>
    <div class="right">
      <div class="content">
        <ConfigDetailVue
          :perviewRole="'c'"
          :content="formData.content"
          :tags="formData.tags"
          :product-data="formData.productData"
        ></ConfigDetailVue>
      </div>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import XrkTinymce from '@/components/xrk/tinymce';
import { computed, reactive, ref, nextTick } from 'vue';
import {
  BaseButton,
  BaseButtonProps,
  BaseCheckbox,
  BaseCheckboxGroup,
  BaseEmpty,
  BaseForm,
  BaseFormItem,
  BaseFormRef,
  BaseIcon,
  BaseInput,
  XrkMessage,
  createDialog,
  BaseUpload,
  BaseImage,
  BaseTextContent
} from 'xrk-components';
import { ConfigProductVue, chooseProduct } from '../components/config-product';
import { ConfigTagsVue, chooseTags } from '../components/config-tags';
import { Zs, Product, TagType, ZsEditType } from '../data-source/types';
import {
  CircleCheckFilled,
  WarningFilled,
  CircleCloseFilled
} from '@element-plus/icons-vue';
import { ConfigDetailVue } from '../components/config-detail';
import { useZsStore } from '../store';
import {
  ROAD_TYPE,
  ROAD_TYPE_MAP,
  STATUS_NO_CONFIRM_VALUE,
  STATUS_NO_RELEASED_VALUE,
  STATUS_REJECT_VALUE,
  STATUS_RELEASED_VALUE,
  STATUS_SUSPEND_VALUE,
  PUBLISH_SOURCE_SYSTEM,
  PUBLISH_SOURCE_COMPANY,
  ROAD_WEB_VALUE,
  ROAD_MINI_VALUE,
  ROAD_APP_VALUE
} from '../config';
import {
  editConfig,
  getConfig,
  setConfigStatus,
  autoUploadImge,
  queryZsProtocol
} from '../data-source/api';
import router from '@/router';
import { useRoute } from 'vue-router';
import { imgSvg } from '../router/index';
import { usePreviewWebviewInvestmentUrl } from '@hooks/webview';

const route = useRoute();

const {
  isOwnPublish,
  isOtherPublish,
  isOssRole,
  enterpriseId,
  enterpriseName,
  setValue,
  configId
} = useZsStore();

const ConfigTagsRef = ref<InstanceType<typeof ConfigTagsVue>>();
const ConfigProductRef = ref<InstanceType<typeof ConfigProductVue>>();

const _roleName = isOssRole.value ? '企业' : '平台';
const configStatusMap = {
  review: {
    icon: WarningFilled,
    color: '--xrk-color-primary',
    message: `提示：招商内容已发布，${_roleName}审核中`
  },
  success: {
    icon: CircleCheckFilled,
    color: '--xrk-color-success',
    message: `提示：${_roleName}已审核通过`
  },
  fail: {
    icon: CircleCloseFilled,
    color: '--xrk-color-error',
    message: '驳回：'
  }
};
const zsIsAudit = ref(0);
const loading = ref(true);
const isStop = ref(false);
const configStatus = ref<keyof typeof configStatusMap | ''>('');
const failReason = ref('');
const configStatusObj = computed(() => {
  const res = configStatusMap[configStatus.value];
  if (!res) return void 0;
  return {
    ...res,
    message:
      configStatus.value === 'fail'
        ? `${res.message}${failReason.value}`
        : res.message
  };
});
const edit = ref(false);
const formData = reactive<{
  id?: number;
  content: Zs['row']['introduce'];
  productData: Zs['row']['productList'];
  tags: Zs['row']['tags'];
  platforms: Zs['row']['platforms'];
}>({
  content: '',
  productData: [],
  tags: [],
  platforms: Object.keys(ROAD_TYPE_MAP) as any
});

//logo_________________
const loginFileList = ref([]);
let logoFormData = ref({
  enterpriseLogo: '',
  agreement: false,
  agreementDiseab: false
});

const logoHttpRequest = async ({ file }) => {
  const res = await autoUploadImge({ file });
  logoFormData.value.enterpriseLogo = res.data.fileUrl;
};
const logoError = errorInfo => {
  if (errorInfo.code == 501) {
    XrkMessage.error('图片最大支持200k');
  }
  if (errorInfo.code == 503) {
    XrkMessage.error('图片类型为jpg、jpeg、png');
  }
};
const agreementDioalog = async () => {
  let res = await queryZsProtocol();
  createDialog({
    title: '向日葵平台企业招商服务使用及管理规则',
    showClose: true,
    showFooter: false,
    width: '960px',
    contentRender: () => {
      return (
        <BaseTextContent>
          <div
            v-html={res.data.content}
            style={{ background: '#F2F2F7', borderRadius: '8px 8px 8px 8px' }}
          ></div>
        </BaseTextContent>
      );
    }
  });
};

const initData = async () => {
  try {
    if (isOssRole.value && !configId.value) {
      edit.value = true;
      loading.value = false;
      configStatus.value = '';
      formData.platforms = Object.keys(ROAD_TYPE_MAP).map(i => +i) as any;
      return;
    }
    const { data } = await getConfig({ configId: configId.value });
    if (!data) {
      edit.value = true;
      loading.value = false;
      configStatus.value = '';
    } else if (data && Object.keys(data).length > 0) {
      logoFormData.value.enterpriseLogo = data.enterpriseLogo;
      loginFileList.value = [
        {
          url: data.enterpriseLogo,
          name: '企业logo'
        }
      ];
      logoFormData.value.agreement = data.agreementDt ? true : false;
      logoFormData.value.agreementDiseab = data.agreementDt ? true : false;
      formData.id = data.id;
      formData.content = data.introduce;
      formData.productData = data.productList;
      formData.tags = data.tags;
      formData.platforms = data.platforms;
      zsIsAudit.value = data.zsIsAudit;
      switch (data.auditStatus) {
        case STATUS_NO_RELEASED_VALUE:
          configStatus.value = '';
          break;
        case STATUS_NO_CONFIRM_VALUE:
          configStatus.value = 'review';
          break;
        case STATUS_RELEASED_VALUE:
          configStatus.value = 'success';
          break;
        case STATUS_REJECT_VALUE:
          configStatus.value = 'fail';
          break;
        case STATUS_SUSPEND_VALUE:
          {
            configStatus.value = 'success';
            isStop.value = true;
          }
          break;
      }
      failReason.value = data.reason || '';
      edit.value = !['review', 'success', 'fail'].includes(configStatus.value);
      if (
        (isOssRole.value && data.source == PUBLISH_SOURCE_SYSTEM) ||
        (!isOssRole.value && data.source == PUBLISH_SOURCE_COMPANY)
      ) {
        setValue('dataOrigin', 'own');
      } else {
        setValue('dataOrigin', 'other');
      }
    }
    loading.value = false;
  } catch (error) {
    loading.value = false;
  }
};

const onTinymceInput = (value: string) => {
  formData.content = value;
};

const onAddProductClick = async () => {
  const data = (await chooseProduct(
    new Set(formData.productData.map(i => i.productId as number))
  )) as any;
  ConfigProductRef.value?.pushData?.(data);
};

const onAddTagsClick = async () => {
  const data = await chooseTags(
    new Set(formData.tags?.map(i => i.id as number))
  );
  formData.tags.push(
    ...data.map(i => ({ ...i, required: true, chooseTagValues: [] }))
  );

  nextTick(() => {
    const el = document.querySelector('.ability-label');
    el?.scrollIntoView({
      block: 'end',
      inline: 'center',
      behavior: 'smooth'
    });
  });
};
initData().then(() => {
  nextTick(() => {
    formData.productData.length > 0 &&
      ConfigProductRef.value?.pushData?.(
        formData.productData as Array<Product['row']>
      );
  });
});

const checkFormData = (() => {
  const TEXT_MAX_LENGTH = 2000;
  const PRODUCT_MIN_COUNT = 1;
  const PRODUCT_MAX_COUNT = 30;
  const TAG_MIN_COUNT = 1;
  const TAG_MAX_COUNT = 10;
  return async () => {
    let errStr = '';
    const checks = [
      () => {
        if (!formData.content) return;
        const div = document.createElement('div');
        div.innerHTML = formData.content;
        // eslint-disable-next-line no-irregular-whitespace
        const text = div.innerText.replace(/[\n|' '|' ']/g, '');
        if (text.length > TEXT_MAX_LENGTH)
          return `富文本编辑器最多输入${TEXT_MAX_LENGTH}字符长度内容`;
        return '';
      },
      () => {
        if (
          formData.productData.length > PRODUCT_MAX_COUNT ||
          formData.productData.length < PRODUCT_MIN_COUNT
        ) {
          return `至少需要添加${PRODUCT_MIN_COUNT}个产品，最多添加${PRODUCT_MAX_COUNT}个`;
        }
        return '';
      },
      () => {
        if (
          formData.tags.length > TAG_MAX_COUNT ||
          formData.tags.length < TAG_MIN_COUNT
        ) {
          return `能力标签至少需要添加${TAG_MIN_COUNT}个能力标签，最多添加${TAG_MAX_COUNT}个`;
        }
        const emptyTag = formData.tags.find(
          item => item.chooseTagValues?.length == 0
        );
        if (emptyTag) return `${emptyTag.name}至少选择一项`;
        return '';
      }
    ];
    for (const check of checks) {
      let _err = check();
      if (_err) {
        errStr = _err;
        break;
      }
    }
    if (errStr) {
      XrkMessage.error(errStr);
      return Promise.reject(errStr);
    }
    return Promise.resolve();
  };
})();

const cancelBtnConfig: BaseButtonProps & { show: boolean; content: string } = {
  show: true,
  type: 'default',
  content: '取消'
};
const confirmBtnConfig: BaseButtonProps & { show: boolean; content: string } = {
  show: true,
  type: 'primary',
  content: '确认'
};

const saveConfig = async (isPublish: 0 | 1) => {
  const { data: _configId } = await editConfig({
    enterpriseLogo: logoFormData.value.enterpriseLogo,
    enterpriseId: enterpriseId.value,
    id: formData.id,
    introduce: formData.content,
    productIdList: formData.productData.map(i => i.productId as number),
    isPublish: isPublish,
    zsWebIsShow: formData.platforms.includes(ROAD_WEB_VALUE) ? 1 : 0,
    zsWxIsShow: formData.platforms.includes(ROAD_MINI_VALUE) ? 1 : 0,
    zsAppIsShow: formData.platforms.includes(ROAD_APP_VALUE) ? 1 : 0,
    labelList: formData.tags.map(tag => ({
      labelId: (tag.id && +tag.id) as number,
      isMustFill: tag.required ? 1 : 0,
      isLocation: tag.isLocation ? 1 : 0,
      optionIdList: (tag.chooseTagValues?.map(i => +i) || []).filter(
        Boolean
      ) as number[],
      areaList: tag.chooseTagValues
        ?.map(area => {
          if (Array.isArray(area)) {
            return {
              provinceId: area[0],
              cityId: area[1],
              isAll: tag._provinceChooseAllMap.get(+area[0]) || false
            };
          }
          return {
            provinceId: 0,
            cityId: 0
          };
        })
        .filter(
          i => i.provinceId
        ) as ZsEditType['labelList'][number]['areaList']
    }))
  });
  _configId &&
    (formData.id = _configId) &&
    configId.value != _configId &&
    router.replace({
      query: {
        ...(route.query || {}),
        configId: _configId
      }
    });
};

const onSaveClick = async () => {
  // 保存
  // if ([null, '', undefined].includes(logoFormData.value.enterpriseLogo)) {
  //   XrkMessage.error('请上传企业logo');
  //   return;
  // }
  // if (!logoFormData.value.agreement) {
  //   XrkMessage.error('请勾选《向日葵平台企业招商服务使用及管理规则》同意条款');
  //   return;
  // }
  await checkFormData();
  await saveConfig(0);
  configStatus.value = '';
  XrkMessage.success('保存成功');
};
const onPublishClick = async () => {
  // 发布
  if ([null, '', undefined].includes(logoFormData.value.enterpriseLogo)) {
    XrkMessage.error('请上传企业logo');
    return;
  }
  if (!logoFormData.value.agreement) {
    XrkMessage.error('请勾选《向日葵平台企业招商服务使用及管理规则》同意条款');
    return;
  }
  try {
    await checkFormData();
    await saveConfig(1);
    await initData();
    ConfigTagsRef.value?.initAddressData?.();
  } catch (error) {
    console.log(error);
  }
  // edit.value = false;
  // configStatus.value = 'review';
};
const onStartClick = () => {
  // 启用
  createDialog({
    title: '提示',
    width: 400,
    contentRender: () => (
      <BaseTextContent>
        <p style={'text-align:center;'}>是否确认启用招商？</p>
      </BaseTextContent>
    ),
    cancelBtnConfig,
    confirmBtnConfig,
    beforeConfirm: async () => {
      await setConfigStatus({
        configId: formData.id as number,
        status: STATUS_RELEASED_VALUE
      });
      isStop.value = false;
      XrkMessage.success('操作成功');
    }
  });
};
const onStopClick = () => {
  // 暂停
  createDialog({
    title: '提示',
    width: 400,
    contentRender: () => (
      <BaseTextContent>
        <p style={'text-align:center;'}>是否确认暂停招商？</p>
      </BaseTextContent>
    ),
    cancelBtnConfig,
    confirmBtnConfig,
    beforeConfirm: async () => {
      await setConfigStatus({
        configId: formData.id as number,
        status: STATUS_SUSPEND_VALUE
      });
      isStop.value = true;
      XrkMessage.success('操作成功');
    }
  });
};
const onRevokeClick = async () => {
  const fn = async () => {
    await setConfigStatus({
      configId: formData.id as number,
      status: STATUS_NO_RELEASED_VALUE
    });
    edit.value = true;
    configStatus.value = '';
  };
  // 撤回
  if (zsIsAudit.value == 1 || isOssRole.value) {
    createDialog({
      title: '提示',
      width: 400,
      contentRender: () => (
        <BaseTextContent>
          <p style={'text-align:center;'}>
            撤回后再次提交需要{_roleName}审核，是否确认撤回？
          </p>
        </BaseTextContent>
      ),
      cancelBtnConfig,
      confirmBtnConfig,
      beforeConfirm: fn
    });
  } else {
    await fn();
  }
};
const onReEditClick = async () => {
  // 重新编辑
  const fn = async () => {
    await setConfigStatus({
      configId: formData.id as number,
      status: STATUS_NO_RELEASED_VALUE
    });
    edit.value = true;
    configStatus.value = '';
  };
  if (zsIsAudit.value == 1 || isOssRole.value) {
    createDialog({
      title: '提示',
      width: 400,
      contentRender: () => (
        <BaseTextContent>
          <p style={'text-align:center;'}>
            重新编辑需要{_roleName}再次审核，是否确认重新编辑？
          </p>
        </BaseTextContent>
      ),
      cancelBtnConfig,
      confirmBtnConfig,
      beforeConfirm: fn
    });
  } else {
    await fn();
  }
};

const onSuccessClick = () => {
  if (!logoFormData.value.agreement) {
    XrkMessage.error('请勾选《向日葵平台企业招商服务使用及管理规则》同意条款');
    return;
  }
  // 审核-通过 确认发布
  createDialog({
    title: '提示',
    width: 400,
    contentRender: () => (
      <BaseTextContent>
        <p style={'text-align:center;'}>是否确认发布？</p>
      </BaseTextContent>
    ),
    cancelBtnConfig,
    confirmBtnConfig,
    beforeConfirm: async () => {
      await setConfigStatus({
        configId: formData.id as number,
        status: STATUS_RELEASED_VALUE
      });
      configStatus.value = 'success';
      XrkMessage.success('操作成功');
    }
  });
};
const onFailClick = () => {
  const FailFormRef = ref<BaseFormRef>();
  const failFormData = reactive({
    reason: ''
  });
  // 审核-不通过  驳回修改
  createDialog({
    title: '提示',
    width: 400,
    contentRender: () => (
      <BaseTextContent>
        <BaseForm
          model={failFormData}
          ref={FailFormRef}
          rules={{ reason: { required: true, message: '填写驳回原因' } }}
        >
          <BaseFormItem prop={'reason'}>
            <BaseInput
              style={{ width: '100%' }}
              type="textarea"
              resize="none"
              modelValue={failFormData.reason}
              onInput={(val: string) => (failFormData.reason = val)}
              maxlength={100}
              showWordLimit
              rows={4}
              placeholder="请输入驳回原因（最多100字符长度）"
            ></BaseInput>
          </BaseFormItem>
        </BaseForm>
      </BaseTextContent>
    ),
    cancelBtnConfig,
    confirmBtnConfig,
    beforeConfirm: async () => {
      await FailFormRef.value?.validate();
      await setConfigStatus({
        configId: formData.id as number,
        status: STATUS_REJECT_VALUE,
        reason: failFormData.reason
      });
      configStatus.value = 'fail';
      XrkMessage.success('操作成功');
    }
  });
};

const onCopyClick = async () => {
  // await checkFormData();
  // await saveConfig(0);
  // 保存后可用
  const input = document.createElement('input') as HTMLInputElement;
  input.style.opacity = '0';
  input.style.position = 'fixed';
  input.value = usePreviewWebviewInvestmentUrl(configId.value);
  document.body.appendChild(input);
  input.select();
  document.execCommand('Copy');
  document.body.removeChild(input);
  XrkMessage.success('复制成功');
};
const previewLogo = url => {
  createDialog({
    title: '预览',
    width: 500,
    showClose: true,
    contentRender: () => (
      <BaseTextContent>
        <img style={{ width: '100%', height: '100%' }} src={url}></img>
      </BaseTextContent>
    ),
    cancelBtnConfig: {
      show: false
    },
    confirmBtnConfig: {
      show: false
    }
  });
};
</script>

<style lang="scss" scoped>
.config {
  display: flex;
  gap: 18px;
  height: 100%;
  text-align: left;
}
.left {
  height: 100%;
  flex-grow: 1;
  min-width: 600px;
  max-width: 1300px;
  display: flex;
  flex-direction: column;
  .left_wrap {
    flex: 1;
    height: 100%;
    width: 100%;
    overflow: auto;
    overflow-x: hidden;
  }

  .enterprise-setting {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 18px;
    // position: sticky;
    // top: 0;
    // left: 0;
    // background-color: #fff;
    // z-index: 2;
    padding-bottom: 12px;
    .choose {
      width: 60%;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      font-size: 14px;
      gap: 12px;
      .box {
        border: 1px solid #e5e5e5;
        flex-grow: 1;
        border-radius: 4px;
        padding: 0 12px;
      }
    }
  }
  .dis-edit {
    pointer-events: none;
    opacity: 0.5;
  }
  ::v-deep {
    .mce-stack-layout-item:has(.mce-wordcount) {
      display: none;
    }
  }
  .item + .item {
    margin-top: 24px;
  }
  .title {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 24px;

    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #121619;
    line-height: 28px;
    text-align: left;
    font-style: normal;
    text-transform: none;

    .btn {
      margin-left: 18px;
    }
  }
}
.right {
  background-image: url('https://cdn.yxvzb.com/WEB/SaaS/images/phone.5460695e.png');
  width: 360px;
  height: 730px;
  flex-shrink: 0;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 48px 24px 32px 32px;
  .content {
    padding-right: 12px;
    overflow: auto;
    height: 100%;
  }
}
</style>
